import { createAction } from '@reduxjs/toolkit';
import { createActionWithCallback } from 'core/store/utils';
import { RequestError, HelpInfo, CreateHelpInfoParams, UpdateHelpInfoParams, HelpInfosFilter } from 'types';

export const createHelpInfo = createActionWithCallback<void, Error>()(
  'help-info/create-help-info',
  (helpInfo: CreateHelpInfoParams) => ({
    payload: helpInfo,
  })
);

export const createdHelpInfo = createAction('help-info/created-help-info', (data?: HelpInfo, error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export const updateHelpInfo = createActionWithCallback<void, Error>()(
  'help-info/update-help-info',
  (helpInfo: UpdateHelpInfoParams) => ({
    payload: helpInfo,
  })
);

export const updatedHelpInfo = createAction('help-info/updated-help-info', (data?: HelpInfo, error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export const deleteHelpInfo = createAction(
  'help-info/delete-help-info',
  (id: string, filterValues?: HelpInfosFilter) => ({
    payload: { id, filterValues },
    meta: { id },
  })
);

export const deletedHelpInfo = createAction('help-info/deleted-help-info', (data?: boolean, error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export default {
  createHelpInfo,
  createdHelpInfo,
  updateHelpInfo,
  updatedHelpInfo,
  deleteHelpInfo,
  deletedHelpInfo,
};
